import { render, staticRenderFns } from "./inbound.vue?vue&type=template&id=bcd8d0be&scoped=true&"
import script from "./inbound.vue?vue&type=script&lang=js&"
export * from "./inbound.vue?vue&type=script&lang=js&"
import style0 from "./inbound.vue?vue&type=style&index=0&id=bcd8d0be&scoped=true&lang=css&"
import style1 from "./inbound.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd8d0be",
  null
  
)

export default component.exports